import axiosCustom from "./axios.custom";
import { Auth } from "../services/authService";
import { USERID } from "../config/constants";

const authController = new Auth();
const { BACKEND_URL } = require("../config/config");
const idUser = localStorage.getItem(USERID);

export function obtenerExpedientes(
  id,
  limit = 10,
  page = 1,
  orderByField = "expediente_req_historico.fecha",
  orderByDirection = "desc",
  incluirFinalizados = false
) {
  const token = authController.getAccessToken();

  if (id && token) {
    const url = `/expedientePorUsuario/${id}?limit=${limit}&page=${page}&orderByField=${orderByField}&orderByDirection=${orderByDirection}&incluirFinalizados=${incluirFinalizados}`;

    return axiosCustom.get(url, {
      headers: {
        Authorization: token,
      },
    });
  }
}
export function obtenerExpedientePorId(id) {
  const token = authController.getAccessToken();
  const url = `/expediente/${id}`;

  return axiosCustom.get(url, {
    headers: {
      Authorization: token,
    },
  });
}

export function eliminarExpediente(id) {
  const token = authController.getAccessToken();
  const url = `/expediente/${id}`;

  return axiosCustom.delete(url, {
    headers: {
      Authorization: token,
    },
  });
}

export async function descargarArchivosExpediente(id) {
  const token = authController.getAccessToken();
  const url = `/filesExpediente/${id}`;

  const response = await axiosCustom.get(url, {
    headers: {
      Authorization: token,
    },
    responseType: "blob",
    validateStatus: (status) => true, // ⬅️ Importante para no lanzar error automáticamente
  });

  if (response.status === 204) {
    throw new Error("NO_ARCHIVOS");
  }

  const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = blobUrl;
  link.setAttribute("download", `expediente_${id}.zip`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
}


export function createExpedient(data) {
  const token = authController.getAccessToken();
  const url = `/expediente`;

  return axiosCustom.post(
    url,
    data, // Pass data as the second argument
    {
      headers: {
        Authorization: `Bearer ${token}`, // Ensure token is prefixed with Bearer if required by your backend
        "Content-Type": "application/json", // Ensure the content type is set correctly
      },
    }
  );
}

export function updateExpediente(id, data) {
  const token = authController.getAccessToken();
  const url = `/expediente/${id}`; // Incorpora el ID del expediente en la URL

  return axiosCustom.put(
    url,
    data, // Los datos actualizados del expediente
    {
      headers: {
        Authorization: `Bearer ${token}`, // Asegúrate de incluir el token de autorización si es necesario
        "Content-Type": "application/json", // Asegúrate de que el tipo de contenido esté configurado correctamente
      },
    }
  );
}

export function moverDeOficina(id, data) {
  const token = authController.getAccessToken();
  const url = `/expediente/${id}`; // Incorpora el ID del expediente en la URL

  return axiosCustom.put(
    url,
    data, // Los datos actualizados del expediente
    {
      headers: {
        Authorization: `Bearer ${token}`, // Asegúrate de incluir el token de autorización si es necesario
        "Content-Type": "application/json", // Asegúrate de que el tipo de contenido esté configurado correctamente
      },
    }
  );
}

export async function getRequisitos(id) {
  const token = authController.getAccessToken();
  const url = `/requisitosporexpediente/${id}`;

  return axiosCustom.get(url, {
    headers: {
      Authorization: token,
    },
  });
}

export async function obtenerSeguimiento(id) {
  try {
    const token = authController.getAccessToken();
    const url = `/expedienteporoficina/${id}`;

    return axiosCustom.get(url, {
      headers: {
        Authorization: token,
      },
    });
  } catch (error) {
    console.log("error al obtener expediente por oficina", error);
    throw error;
  }
}

export async function addExpedienteRequisito(data) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/expedienteRequisito`;

  return axiosCustom.post(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

export async function agregarPlantillaRequisito(data) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/agregarPlantillaRequisito`;

  return axiosCustom.post(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

export async function getUsersList(idUser) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/usuario?exclude=${idUser}`;
  return axiosCustom.get(url, {
    headers: {
      Authorization: token,
    },
  });
}

export async function getUsersByExpedienteList(idUser, idExpediente) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/usuarioPorExpediente/${idExpediente}?exclude=${idUser}`;
  return axiosCustom.get(url, {
    headers: {
      Authorization: token,
    },
  });
}

export async function getUsuariosInternos() {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/getUsuariosInternos`;
  return axiosCustom.get(url, {
    headers: {
      Authorization: token,
    },
  });
}

export async function getSharedUsersList(id_expediente) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/sharedUsersByExpediente/${id_expediente}`;
  return axiosCustom.get(url, {
    headers: {
      Authorization: token,
    },
  });
}

export async function completarRequisito(data) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/completarRequisito`;

  return axiosCustom.put(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

export async function validarRequisito(data) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/validarRequisito`;

  return axiosCustom.put(url, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

export async function getDocumentosAprobadosPorExpediente(id) {
  try {
    const token = authController.getAccessToken();
    const url = `${BACKEND_URL}/documentosaprobados/${id}`;

    return axiosCustom.get(url, {
      headers: {
        Authorization: token,
      },
    });
  } catch (error) {
    console.log("error al obtener documentos aprobados por expediente", error);
    throw error;
  }
}

export async function eliminarRequisitoDeExpediente(id) {
  try {
    const token = authController.getAccessToken();
    const url = `${BACKEND_URL}/expedienteRequisito/${id}`;

    return axiosCustom.delete(url, {
      headers: {
        Authorization: token,
      },
    });
  } catch (error) {
    console.log("Error al eliminar requisito de expediente", error);
    throw error;
  }
}

export async function cambiarOpcionalidadDeRequisito(id_mov, value) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/cambiarOpcionalidadDeRequisito/${id_mov}`;

  return axiosCustom.put(
    url,
    { opcional: value },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}

export async function compartirExpediente(users, id_expediente) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/compartirExpediente/${id_expediente}`;
  return axiosCustom.put(
    url,
    { users: users },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}

export async function reabrirExpediente(id_expediente) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/reabrirExpediente/${id_expediente}`;
  return axiosCustom.put(
    url,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}
